(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHotspots);
  } else {
    initHotspots();
  }

  function initHotspots() {
    const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const sections = document.querySelectorAll('.mad-spec-section');
    
    sections.forEach(section => {
      const hotspots = section.querySelectorAll('.mad-hotspot');
      
      hotspots.forEach(btn => {
        let open = false;

        const openIt = () => { 
          closeAllHotspots(section);
          btn.classList.add('is-open'); 
          btn.setAttribute('aria-expanded','true'); 
          open = true;
        };
        
        const closeIt = () => { 
          btn.classList.remove('is-open'); 
          btn.setAttribute('aria-expanded','false'); 
          open = false;
        };

        if(isDesktop){
          btn.addEventListener('mouseenter', openIt);
          btn.addEventListener('mouseleave', closeIt);
        }

        btn.addEventListener('click', function(e){
          e.stopPropagation();
          open ? closeIt() : openIt();
        });

        btn.addEventListener('keydown', function(e){ 
          if(e.key === 'Escape') closeIt();
        });
      });
    });

    document.addEventListener('click', function(e){
      if (!e.target.closest('.mad-hotspot')) {
        closeAllHotspots();
      }
    });

    function closeAllHotspots(specificSection = null) {
      const sectionsToClose = specificSection ? [specificSection] : document.querySelectorAll('.mad-spec-section');
      
      sectionsToClose.forEach(section => {
        section.querySelectorAll('.mad-hotspot.is-open').forEach(hotspot => {
          hotspot.classList.remove('is-open');
          hotspot.setAttribute('aria-expanded','false');
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
